import { AppUtil } from 'kuaidong-lib'

import {
  IMallCourseCreateOrderForm,
  IMallCourseDetail,
  IMallCourseInfo,
  IMallCourseList,
  IMallCourseOrderCallback,
  IMallCourseOrderInfo,
  IMallCourseOrderList,
  IMallCoursePayStatusRes,
  IWXPayParams,
} from 'kuaidong-model'

export class ACourseCenter {
  static async courseList(limit: number | null = null, offset: number | null = null): Promise<IMallCourseList> {
    return AppUtil.httpGET('/mall_course/list', { limit, offset })
  }

  static async courseDetail(mall_course_id: string): Promise<IMallCourseDetail> {
    return AppUtil.httpGET('/mall_course/detail', { mall_course_id })
  }

  static async courseSubmit(orderForm: IMallCourseCreateOrderForm): Promise<IMallCourseInfo> {
    return AppUtil.httpPOST('/mall_course/submit', orderForm)
  }

  static async orderList(limit?: number, offset?: number): Promise<IMallCourseOrderList> {
    return AppUtil.httpGET('/mall_course/order/list', { limit, offset })
  }

  static async orderDetail(outer_order_id: string): Promise<IMallCourseOrderInfo> {
    return AppUtil.httpGET('/mall_course/order/detail', { outer_order_id })
  }

  static async courseOrderCallback(orderCallBackForm: IMallCourseOrderCallback): Promise<void> {
    return AppUtil.httpPOST('/mall_course/order/callback', orderCallBackForm)
  }

  static async mallCourseAliH5Pay(order_id: string): Promise<{ response_data: { url: string } }> {
    return AppUtil.httpPOST('/mall_course/ali_h5_pay', { order_id })
  }

  static async mallCourseWxPay(order_id: string, open_id: string): Promise<{ response_data: IWXPayParams }> {
    return AppUtil.httpPOST('/mall_course/wx_jsapi_pay', { order_id, open_id })
  }

  static async mallOrderStatus(order_id: string): Promise<IMallCoursePayStatusRes> {
    return AppUtil.httpGET('/mall_course/order/status', { order_id })
  }
}
